import { render, staticRenderFns } from "./ForecastingOptimizationSetup.vue?vue&type=template&id=a5ae59a2&scoped=true"
import script from "./ForecastingOptimizationSetup.vue?vue&type=script&lang=js"
export * from "./ForecastingOptimizationSetup.vue?vue&type=script&lang=js"
import style0 from "./ForecastingOptimizationSetup.vue?vue&type=style&index=0&id=a5ae59a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ae59a2",
  null
  
)

export default component.exports